import { Component } from '@angular/core';

@Component({
  selector: 'elcia-no-page',
  imports: [],
  templateUrl: './no-page.html',
  styleUrl: './no-page.scss',
})
export class NoPage {

}
